// Sélectionner le seul iframe sur la page
const iframe = document.querySelector('.play-iframe iframe');
if (iframe) {
  const src = iframe.getAttribute('src');
  iframe.setAttribute('src', `${src}?autoplay=1&muted=1&loop=1&background=1`);

  const player = new Vimeo.Player(iframe, {
    // Paramètre background pour masquer les contrôles
    background: true
  });

  player.setVolume(0);
  player.setLoop(true);

  // Démarrer automatiquement la vidéo
  player.play().catch(error => {
    console.error('Erreur lors du démarrage de la vidéo :', error);
  });

  iframe.style.width = '800px !important'; // Définir la largeur
  iframe.style.height = '800px !important'; // Définir la hauteur
}
